"use client";

import {
	TenantPrivacyPolicyLink,
	TenantTermsAndConditionsLink,
} from "@/tenants/components";
import CarusoGeneralTermsLink from "@/tenants/components/CarusoGeneralTermsLink";
import TenantName from "@/tenants/components/TenantName";
import { useActiveTenant } from "@/tenants/TenantProvider";
import { CARUSO_MARKETING_SITE } from "@/constants/external-links";
import { cn, textVariants } from "@jasperlabs/ui";
import React from "react";

const Footer = () => {
	const tenant = useActiveTenant();
	const tenantSlug = encodeURIComponent(
		tenant?.tenantName?.toLowerCase().replace(/\s+/g, "-") ?? "unknown",
	);
	const carusoUrlWithUtm = `${CARUSO_MARKETING_SITE}?utm_source=investor-portal&utm_medium=internal-nav&utm_campaign=${tenantSlug}&utm_content=footer`;

	return (
		<footer className="bg-neutral-100 py-4 md:py-6 justify-self-end w-full">
			<div
				className={cn(
					"flex flex-col items-center justify-center md:flex-row md:justify-between gap-y-2",
					textVariants({ variant: "body-sm" }),
					"w-full px-5",
				)}
			>
				<a
					href={carusoUrlWithUtm}
					target="_blank"
					rel="nofollow noreferrer"
					className={cn(
						textVariants({ variant: "body-sm" }),
						"text-neutral-500",
					)}
				>
					Investor Portal by Caruso
				</a>
				<div className="hidden md:flex md:flex-row flex-col gap-x-16 gap-y-2 text-neutral-500">
					<div>
						<TenantName />{" "}
						<TenantTermsAndConditionsLink className="text-neutral-500">
							terms
						</TenantTermsAndConditionsLink>{" "}
						&{" "}
						<TenantPrivacyPolicyLink className="text-neutral-500">
							privacy
						</TenantPrivacyPolicyLink>
					</div>
					<div>
						Caruso{" "}
						<CarusoGeneralTermsLink className="text-neutral-500">
							terms
						</CarusoGeneralTermsLink>{" "}
						&{" "}
						<CarusoGeneralTermsLink className="text-neutral-500">
							privacy
						</CarusoGeneralTermsLink>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
